module.exports = {
  localeName: 'da-DK',
  momentFormat: 'DD-MM-YYYY'
};
